import { useCallback } from 'react'
import { RawImageMessage } from '@weblite/ts-action/message'
import { useContentFileStatus } from '$common/react-hooks/message'
import { showMediaViewerModal } from '$comp/modals/media-viewer'
import { MediaWrapper } from '../../media-wrapper'

export function Image({
  attachment,
  selected,
  selectOnTap,
  roomId,
  iid,
}: {
  attachment: RawImageMessage['attachment']
  selected: boolean
  selectOnTap: boolean
  roomId: string
  iid: number
}) {
  const { fileId, base64 } = attachment

  const { blobURL } = useContentFileStatus({
    fileId,
    uploadId: null,
    messageType: 'IMAGE',
  })

  const openImage = useCallback(async () => {
    if (selectOnTap) return
    showMediaViewerModal({ roomId, iid })
  }, [selectOnTap])

  return (
    <MediaWrapper selected={selected}>
      <img
        src={blobURL || base64}
        alt="image-message"
        onClick={openImage}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          cursor: 'pointer',
          opacity: selected ? 0.4 : 1,
          transition: 'opacity 0.2s',
        }}
      />
    </MediaWrapper>
  )
}
